export const CONTACT_OPTIONS = [
   {
      label: 'Phone',
      value: 'Phone',
   },
   {
      label: 'Text',
      value: 'Text',
   },
   {
      label: 'Email',
      value: 'Email',
   },
];

export const TITLE_OPTIONS = [
   {'label': 'Mr', value: 'Mr', key: 'mr'},
   {'label': 'Mrs', value: 'Mrs', key: 'mrs'},
   {'label': 'Miss', value: 'Miss', key: 'miss'},
   {'label': 'Ms.', value: 'Ms.', key: 'ms'},
   {'label': 'Dr (Male)', value: 'Dr (Male)', key: 'dr-male'},
   {'label': 'Dr (Female)', value: 'Dr (Female)', key: 'dr-female'},
];

export const TITLE_OPTIONS_WITH_PLACEHOLDER = [
   {label: 'Please select', value: ''},
   ...TITLE_OPTIONS,
]

export const YES_NO_CHOICE_OPTIONS = [
   {label: 'Yes', value: 'Yes'},
   {label: 'No', value: 'No'},
];

export const YES_NO_CHOICE_OPTIONS_WITH_PLACEHOLDER = [
   {label: 'Please select', value: ''},
   ...YES_NO_CHOICE_OPTIONS,
]

export const MARITAL_STATUS_OPTIONS = [
   {label: 'Please Select', value: ''},
   {label: 'Single', value: 'Single'},
   {label: 'Married', value: 'Married'},
   {label: 'Living With Partner', value: 'Living With Partner'},
   {label: 'Civil Partner', value: 'Civil Partner'},
   {label: 'Divorced', value: 'Divorced'},
   {label: 'Widowed', value: 'Widowed'},
   {label: 'Separated', value: 'Separated'},
];

export const EMPLOYMENT_STATUS_REQUIRING_OCCUPATION_OPTIONS = [
   'Employed',
   'Self-Employed',
];

export const EMPLOYMENT_STATUS_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "Employed",
      "value": "Employed"
   },
   {
      "label": "Unemployed",
      "value": "Unemployed"
   },
   {
      "label": "Self-Employed",
      "value": "Self-Employed"
   },
   {
      "label": "House Person",
      "value": "House Person"
   },
   {
      "label": "Education",
      "value": "Education"
   },
   {
      "label": "Retired",
      "value": "Retired"
   },
   {
      "label": "Voluntary",
      "value": "Voluntary"
   },
   {
      "label": "Independent means",
      "value": "Independent means"
   },
   {
      "label": "Not employed due to disability",
      "value": "Not employed due to disability"
   }
];

export const DRIVING_LICENSE_TYPE_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "Full UK Manual", "value": "Full UK Manual"},
   {"label": "Full UK Automatic", "value": "Full UK Automatic"},
   {"label": "Provisional UK", "value": "Provisional UK"},
   {"label": "Full UK-Pass Plus", "value": "Full UK-Pass Plus"},
   {"label": "Full UK-IAM", "value": "Full UK-IAM"},
   {"label": "Full Euro EEC", "value": "Full Euro EEC"},
   {"label": "International Licence (NON-Exchangeable)", "value": "International Licence (NON-Exchangeable)"},
   {"label": "International Licence (Exchangeable)", "value": "International Licence (Exchangeable)"}
];

export const DRIVING_LICENSE_DURATION_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "Less than a year", "value": "Less than a year"},
   {"label": "1 year", "value": "1 year"},
   {"label": "2 years", "value": "2 years"},
   {"label": "3 years", "value": "3 years"},
   {"label": "4 years", "value": "4 years"},
   {"label": "5 years", "value": "5 years"},
   {"label": "6 years", "value": "6 years"},
   {"label": "7 years", "value": "7 years"},
   {"label": "8 years", "value": "8 years"},
   {"label": "9 years", "value": "9 years"},
   {"label": "10 years", "value": "10 years"},
   {"label": "11 years", "value": "11 years"},
   {"label": "12 years", "value": "12 years"},
   {"label": "13 years", "value": "13 years"},
   {"label": "14 years", "value": "14 years"},
   {"label": "15 years", "value": "15 years"},
   {"label": "16 years", "value": "16 years"},
   {"label": "17 years", "value": "17 years"},
   {"label": "18 years", "value": "18 years"},
   {"label": "19 years", "value": "19 years"},
   {"label": "20 years", "value": "20 years"},
   {"label": "21 years", "value": "21 years"},
   {"label": "22 years", "value": "22 years"},
   {"label": "23 years", "value": "23 years"},
   {"label": "24 years", "value": "24 years"},
   {"label": "25+ years", "value": "25+ years"}
];

export const DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST = [
   "Less than a year",
   "1 year",
   "2 years",
   "3 years",
   "4 years",
];

export const DVLA_MEDICAL_CONDITION_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "No", "value": "No"},
   {"label": "DVLA aware – No restrictions", "value": "DVLA aware – No restrictions"},
   {"label": "DVLA aware – 1 year restricted Licence", "value": "DVLA aware – 1 year restricted Licence"},
   {"label": "DVLA aware – 2 year restricted Licence", "value": "DVLA aware – 2 year restricted Licence"},
   {"label": "DVLA aware – 3 year restricted Licence", "value": "DVLA aware – 3 year restricted Licence"},
   {"label": "DVLA unaware", "value": "DVLA unaware"}
];

export const ADDITIONAL_DRIVING_QUALIFICATION_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "No", "value": "No"},
   {"label": "AA Proficiency", "value": "AA Proficiency"},
   {"label": "Institute of Advance Motorists", "value": "Institute of Advance Motorists"},
   {"label": "Pass Plus", "value": "Pass Plus"}
];

export const OTHER_VEHICLE_USAGE_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "No access to any other vehicle",
      "value": "No access to any other vehicle"
   },
   {
      "label": "Own another car/van",
      "value": "Own another car/van"
   },
   {
      "label": "Have use of another car",
      "value": "Have use of another car"
   },
   {
      "label": "Company car (including personal use)",
      "value": "Company car (including personal use)"
   },
   {
      "label": "Company car (excluding personal use)",
      "value": "Company car (excluding personal use)"
   }
];

export const ALARM_OR_MOBILISER_OPTIONS = [
   {"label": "Please select", "value": ""},
   {
      "label": "Factory Fitted Thatcham Approved Alarm/Immobiliser",
      "value": "Factory Fitted Thatcham Approved Alarm/Immobiliser"
   },
   {"label": "Factory Fitted Thatcham Approved Alarm", "value": "Factory Fitted Thatcham Approved Alarm"},
   {
      "label": "Factory Fitted Non-Thatcham Approved Alarm/Immobiliser",
      "value": "Factory Fitted Non-Thatcham Approved Alarm/Immobiliser"
   },
   {"label": "Factory Fitted", "value": "Factory Fitted"},
   {"label": "None", "value": "None"}
];

export const NUMBER_OF_SEAT_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "1", "value": "1"},
   {"label": "2", "value": "2"},
   {"label": "3", "value": "3"},
   {"label": "4", "value": "4"},
   {"label": "5", "value": "5"},
   {"label": "6", "value": "6"},
   {"label": "7", "value": "7"},
   {"label": "8", "value": "8"},
   {"label": "9", "value": "9"}
];

export const NUMBER_OF_DOOR_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "3 Doors", "value": "3 Doors"},
   {"label": "5 Doors", "value": "5 Doors"}
];

export const CAR_TRANSMISSION_TYPES_OPTIONS = [
   {label: 'Please Select', value: ''},
   {"label": "Manual", "value": "Manual"},
   {"label": "Automatic", "value": "Automatic"}
];

export const carModificationTypes = [
   {"label": "Please select", "value": ""},
   {"label": "Accessories", "value": "Accessories"},
   {"label": "Body Mods", "value": "Body Mods"},
   {"label": "Brakes", "value": "Brakes"},
   {"label": "Engine/Transmission", "value": "Engine/Transmission"},
   {"label": "Paintwork/Stickers", "value": "Paintwork/Stickers"},
   {"label": "Spoilers/Body kits", "value": "Spoilers/Body kits"},
   {"label": "Suspension/Steering", "value": "Suspension/Steering"},
   {"label": "Wheels & Tyres", "value": "Wheels &amp; Tyres"}
];

export const CAR_OWNER_TYPE_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "Policyholder", "value": "Policyholder"},
   {"label": "Spouse/Partner", "value": "Spouse/Partner"},
   {"label": "Parent", "value": "Parent"},
   {"label": "Son", "value": "Son"},
   {"label": "Daughter", "value": "Daughter"},
   {"label": "Civil Partner", "value": "Civil Partner"},
   {"label": "Common Law Partner", "value": "Common Law Partner"},
   {"label": "Employer", "value": "Employer"},
   {"label": "Company", "value": "Company"},
   {"label": "Limited Company", "value": "Limited Company"},
   {"label": "Lease Company", "value": "Lease Company"},
   {"label": "Society/Club", "value": "Society/Club"},
   {"label": "Other Driver", "value": "Other Driver"}
];

export const VAN_OWNER_TYPE_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "Policyholder", "value": "Policyholder"},
   {"label": "Spouse/Partner", "value": "Spouse/Partner"},
   {"label": "Parent", "value": "Parent"},
   {"label": "Son", "value": "Son"},
   {"label": "Daughter", "value": "Daughter"},
   {"label": "Civil Partner", "value": "Civil Partner"},
   {"label": "Common Law Partner", "value": "Common Law Partner"},
   {"label": "Employer", "value": "Employer"},
   {"label": "Company", "value": "Company"},
   {"label": "Limited Company", "value": "Limited Company"},
   {"label": "Lease Company", "value": "Lease Company"},
   {"label": "Society/Club", "value": "Society/Club"},
   {"label": "Other Driver", "value": "Other Driver"}
];

export const PARKING_DURING_DAY_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "At my home", "value": "At my home"},
   {"label": "Office/Factory Car Park", "value": "Office/Factory Car Park"},
   {"label": "Open public car park", "value": "Open public car park"},
   {"label": "Secure public car park", "value": "Secure public car park"},
   {"label": "Street away from home", "value": "Street away from home"},
   {"label": "Driveway - Gated", "value": "Driveway - Gated"},
   {"label": "Private Garage - Locked", "value": "Private Garage - Locked"}
];

export const PARKING_DURING_NIGHT_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "Private Garage", "value": "Private Garage"},
   {"label": "Public Road", "value": "Public Road"},
   {"label": "Driveway", "value": "Driveway"},
   {"label": "Private Property", "value": "Private Property"},
   {"label": "Car Park", "value": "Car Park"},
   {"label": "Locked Compound", "value": "Locked Compound"}
];

export const CAR_USAGE_TYPE_OPTIONS = [
   {"label": "Please select", "value": ""},
   {
      "label": "Social , Domestic, Pleasure and Commuting (SDPC)",
      "value": "Social , Domestic, Pleasure and Commuting (SDPC)"
   },
   {"label": "Social , Domestic, Pleasure Only (SDP)", "value": "Social , Domestic, Pleasure Only (SDP)"},
   {"label": "SDPC and Business Use (Propose/Spouse only)", "value": "SDPC and Business Use (Propose/Spouse only)"},
   {"label": "SDPC and Business Use (Propose only)", "value": "SDPC and Business Use (Propose only)"},
   {"label": "SDPC and Business Use (Any named driver)", "value": "SDPC and Business Use (Any named driver)"},
   {"label": "SDPC and Business Use - Hot food delivery", "value": "SDPC and Business Use - Hot food delivery"},
];

export const CAR_USAGE_TYPE_OPTIONS_CAR_INSURANCE = [
   
   {
      label : "Social only",
      value : "Social only"
   },
   {
      label : "Social & commuting",
      value : "Social & commuting"
   },
   {
      label : "Business use",
      value : "Business use"
   },
   {
      label : "Hot food Delivery",
      value : "Hot food Delivery"
   }
];

export const ANNUAL_MILEAGE_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "Up to 1000", "value": "Up to 1000"},
   {"label": "Up to 2000", "value": "Up to 2000"},
   {"label": "Up to 3000", "value": "Up to 3000"},
   {"label": "Up to 4000", "value": "Up to 4000"},
   {"label": "Up to 5000", "value": "Up to 5000"},
   {"label": "Up to 6000", "value": "Up to 6000"},
   {"label": "Up to 7000", "value": "Up to 7000"},
   {"label": "Up to 8000", "value": "Up to 8000"},
   {"label": "Up to 9000", "value": "Up to 9000"},
   {"label": "Up to 10000", "value": "Up to 10000"},
   {"label": "Up to 11000", "value": "Up to 11000"},
   {"label": "Up to 12000", "value": "Up to 12000"},
   {"label": "Up to 13000", "value": "Up to 13000"},
   {"label": "Up to 14000", "value": "Up to 14000"},
   {"label": "Up to 15000", "value": "Up to 15000"},
   {"label": "Up to 16000", "value": "Up to 16000"},
   {"label": "Up to 17000", "value": "Up to 17000"},
   {"label": "Up to 18000", "value": "Up to 18000"},
   {"label": "Up to 19000", "value": "Up to 19000"},
   {"label": "Up to 20000", "value": "Up to 20000"},
   {"label": "Up to 21000", "value": "Up to 21000"},
   {"label": "Up to 22000", "value": "Up to 22000"},
   {"label": "Up to 23000", "value": "Up to 23000"},
   {"label": "Up to 24000", "value": "Up to 24000"},
   {"label": "Up to 25000", "value": "Up to 25000"},
   {"label": "Up to 30000", "value": "Up to 30000"},
   {"label": "Up to 35000", "value": "Up to 35000"},
   {"label": "Up to 40000", "value": "Up to 40000"},
   {"label": "Up to 45000", "value": "Up to 45000"},
   {"label": "Up to 50000", "value": "Up to 50000"}
];


export const CAR_INSURANCE_COVERAGE_TYPE_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "Comprehensive", "value": "Comprehensive"},
   {"label": "Third party fire & theft", "value": "Third party fire &amp; theft"},
   {"label": "Third party only", "value": "Third party only"}
];

export const VAN_INSURANCE_COVERAGE_TYPE_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "Comprehensive", "value": "Comprehensive"},
   {"label": "Third party fire & theft", "value": "Third party fire &amp; theft"},
   {"label": "Third party only", "value": "Third party only"}
];

export const NO_CLAIMS_DISCOUNT_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "No NCD", "value": "No NCD"},
   {"label": "1 year", "value": "1 year"},
   {"label": "2 year", "value": "2 year"},
   {"label": "3 years", "value": "3 years"},
   {"label": "4 years", "value": "4 years"},
   {"label": "5 years", "value": "5 years"},
   {"label": "6 years", "value": "6 years"},
   {"label": "7 years", "value": "7 years"},
   {"label": "8 years", "value": "8 years"},
   {"label": "9 years", "value": "9 years"},
   {"label": "10 years", "value": "10 years"},
   {"label": "11 years", "value": "11 years"},
   {"label": "12 years", "value": "12 years"},
   {"label": "13 years", "value": "13 years"},
   {"label": "14 years", "value": "14 years"},
   {"label": "15 years", "value": "15 years"},
   {"label": "16 years", "value": "16 years"},
   {"label": "17 years", "value": "17 years"},
   {"label": "18 years", "value": "18 years"},
   {"label": "19 years", "value": "19 years"},
   {"label": "20 years +", "value": "20 years +"}
];

export const VOLUNTARY_EXCESS_AMOUNT_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "None", "value": "None"},
   {"label": "£50", "value": "£50"},
   {"label": "£100", "value": "£100"},
   {"label": "£200", "value": "£200"},
   {"label": "£250", "value": "£250"},
   {"label": "£300", "value": "£300"},
   {"label": "£350", "value": "£350"},
   {"label": "£400", "value": "£400"},
   {"label": "£500", "value": "£500"}
];

export const insurancePaymentTypes = [
   {"label": "Please select", "value": ""},
   {"label": "Annually", "value": "Annually"},
   {"label": "Monthly", "value": "Monthly"}
];

export const DISCOVERY_TYPES_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "Friends and Family", "value": "Friends &amp; Family"},
   {"label": "Walk-in", "value": "Walk-in"},
   {"label": "Word of Mouth", "value": "Word of Mouth"},
   {"label": "Leaflet", "value": "Leaflet"},
   {"label": "Existing Customer", "value": "Existing Customer"},
   /*{"label": "TV Ad", "value": "TV Ad"},
   {"label": "Email/Newsletter", "value": "Email/Newsletter"},*/
   {"label": "Referrer", "value": "Referrer"},
];

export const DISCOVERY_TYPES_REQUIRES_REFERRER_OPTIONS = [
   "Friends &amp; Family",
   "Existing Customer",
   "Existing/Previous Customer",
   "Friend/Relative",
   "Referrer"
];

export const relationshipsWithPolicyMaker = [
   {"label": "Please select", "value": ""},
   {"label": "Spouse", "value": "Spouse"},
   {"label": "Civil Partner", "value": "Civil Partner"},
   {"label": "Common Law Partner/Cohabitee", "value": "Common Law Partner/Cohabitee"},
   {"label": "Son/Daughter", "value": "Son/Daughter"},
   {"label": "Parent", "value": "Parent"},
   {"label": "Brother/Sister", "value": "Brother/Sister"},
   {"label": "Other Family", "value": "Other Family"},
   {"label": "Employee", "value": "Employee"},
   {"label": "Employer", "value": "Employer"},
   {"label": "Business Partner", "value": "Business Partner"},
   {"label": "Other", "value": "Other"}
];

export const TERMS_AGREEMENT_CHOICE_OPTIONS = [
   {"label": "I Agree", "value": "Yes"},
   {"label": "I Disagree", "value": "No"},
];

export const ACCIDENT_TYPE_OPTIONS = [
   {"label": "Accident", "value": "Accident"},
   {"label": "Windscreen Glass", "value": "Windscreen Glass"},
   {"label": "Theft", "value": "Theft"},
   {"label": "Malicious Damage", "value": "Malicious Damage"},
   {"label": "Storm or Flood", "value": "Storm or Flood"},
   {"label": "Fire", "value": "Fire"},
];

export const ACCIDENT_PARTIES_AT_FAULT_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "Both parties", "value": "Both parties"},
   {"label": "No other vehicle involved", "value": "No other vehicle involved"},
   {"label": "Other party", "value": "Other party"},
   {"label": "Our Driver", "value": "Our Driver"},
   {"label": "Unoccupied Vehicle", "value": "Unoccupied Vehicle"}
];

export const VAN_USAGE_TYPE_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "Carriage Of Own Goods, Not For Hire Or Reward",
      "value": "Carriage Of Own Goods, Not For Hire Or Reward"
   },
   {
      "label": "Haulage(Carriage Of Goods For Hire Or Reward)",
      "value": "Haulage(Carriage Of Goods For Hire Or Reward)"
   },
   {
      "label": "Social, Domestic And Pleasure Only",
      "value": "Social, Domestic And Pleasure Only"
   }
];

export const VAN_BUSINESS_TYPE_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "None",
      "value": "None"
   },
   {
      "label": "Sole Trader",
      "value": "Sole Trader"
   },
   {
      "label": "Limited Company",
      "value": "Limited Company"
   },
   {
      "label": "Partnership",
      "value": "Partnership"
   },
   {
      "label": "Other",
      "value": "Other"
   }
];

export const NCD_EARNING_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "With this vehicle or a previous vehicle",
      "value": "With this vehicle or a previous vehicle"
   },
   {
      "label": "With a company vehicle",
      "value": "With a company vehicle"
   },
   {
      "label": "In another country",
      "value": "In another country"
   }
];

export const NCD_EARNING_PLACE_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "Yes",
      "value": "Yes"
   },
   {
      "label": "No, earned in the European Union",
      "value": "No, earned in the European Union"
   },
   {
      "label": "No, earned in the Rest of the World ",
      "value": "No, earned in the Rest of the World "
   }
];

export const insurancePaymentTypesForVans = [
   {"label": "Please select", "value": ""},
   
   {"label": "Monthly", "value": "Monthly"},
   {"label": "In Full", "value": "In Full"},
];


export const DISCOVERY_TYPES_MOTOR_CYCLE = [
   {
      "label": "Please Select",
      "value": ""
   },
   {
      "label": "Club/Enthusiast Forum",
      "value": "Club/Enthusiast Forum"
   },
   {
      "label": "Dealer/Garage",
      "value": "Dealer/Garage"
   },
   {
      "label": "Directory Enquiries",
      "value": "Directory Enquiries"
   },
   {
      "label": "Existing/Previous Customer",
      "value": "Existing/Previous Customer"
   },
   {
      "label": "Friend/Relative",
      "value": "Friend/Relative"
   },
   {
      "label": "Insurance Broker/Company",
      "value": "Insurance Broker/Company"
   },
   {
      "label": "Leaflet/Letter/Email",
      "value": "Leaflet/Letter/Email"
   },
   {
      "label": "Magazine/Newspaper",
      "value": "Magazine/Newspaper"
   },
   {
      "label": "Previous Vehicle Owner",
      "value": "Previous Vehicle Owner"
   },
   {
      "label": "Price Comparison Website",
      "value": "Price Comparison Website"
   },
   {
      "label": "Search Engine",
      "value": "Search Engine"
   },
   {
      "label": "Show/Event",
      "value": "Show/Event"
   },
   {
      "label": "Website Advert",
      "value": "Website Advert"
   },
   {
      "label": "Other",
      "value": "Other"
   }
];

export const DISCOVERY_TYPES_MOTOR_CYCLE_VALUES = [
   
   "Club/Enthusiast Forum",
   "Dealer/Garage",
   "Directory Enquiries",
   "Existing/Previous Customer",
   "Friend/Relative",
   "Insurance Broker/Company",
   "Leaflet/Letter/Email",
   "Magazine/Newspaper",
   "Previous Vehicle Owner",
   "Price Comparison Website",
   "Search Engine",
   "Show/Event",
   "Website Advert",
   "Other"
];

export const GENDERS = [
   {
      "label": "Male",
      "value": "Male"
   },
   {
      "label": "Female",
      "value": "Female"
   },
   {
      "label": "Not Specified",
      "value": "Not Specified"
   }
];

export const BIKE_RIDER_OPTIONS = [
   {
      "label": 'Please Select',
      "value": ''
   },
   {
      "label": "Insured Only",
      "value": "Insured Only"
   },
   {
      "label": "Insured & Civil Partner",
      "value": "Insured & Civil Partner"
   },
   {
      "label": "Insured & Common Law",
      "value": "Insured & Common Law"
   },
   {
      "label": "Insured and Named Drivers",
      "value": "Insured and Named Drivers"
   },
   {
      "label": "Insured and Spouse",
      "value": "Insured and Spouse"
   }
];

export const BIKE_USAGE_OPTIONS = [
   {
      "label": 'Please Select',
      "value": ''
   },
   {
      "label": "Business Of P/H P/Hs Employer/Ptnr Exc. Com Trav",
      "value": "Business Of P/H P/Hs Employer/Ptnr Exc. Com Trav"
   },
   {
      "label": "Personal Business Use By Policyholder",
      "value": "Personal Business Use By Policyholder"
   },
   {
      "label": "Personal Business Use By Policyholder & Spouse",
      "value": "Personal Business Use By Policyholder & Spouse"
   },
   {
      "label": "Personal Business Use By Spouse",
      "value": "Personal Business Use By Spouse"
   },
   {
      "label": "SDP, Inc. Commuting",
      "value": "SDP, Inc. Commuting"
   },
   {
      "label": "Social Domestic & Pleasure",
      "value": "Social Domestic & Pleasure"
   }
];

export const BIKE_LICENSE_TYPE_OPTIONS = [
   {
      "label": 'Please Select',
      "value": ''
   },
   {
      "label": "A1 Light Motorcycle",
      "value": "A1 Light Motorcycle"
   },
   {
      "label": "Category A",
      "value": "Category A"
   },
   {
      "label": "EEC",
      "value": "EEC"
   },
   {
      "label": "Foreign",
      "value": "Foreign"
   },
   {
      "label": "Full (U.K.)",
      "value": "Full (U.K.)"
   },
   {
      "label": "International",
      "value": "International"
   },
   {
      "label": "Provisional (U.K.)",
      "value": "Provisional (U.K.)"
   },
   {
      "label": "Restricted 3 years or over",
      "value": "Restricted 3 years or over"
   },
   {
      "label": "Restricted less than 3 years",
      "value": "Restricted less than 3 years"
   }
];

export const BIKE_NO_CLAIM_BONUS_YEAR_OPTIONS = [
   {
      "label": 'Please Select',
      "value": ''
   },
   {
      "label": "0 years",
      "value": "0 years"
   },
   {
      "label": "1 year",
      "value": "1 year"
   },
   {
      "label": "2 years",
      "value": "2 years"
   },
   {
      "label": "3 years",
      "value": "3 years"
   },
   {
      "label": "4 years",
      "value": "4 years"
   },
   {
      "label": "5 years",
      "value": "5 years"
   },
   {
      "label": "6 years",
      "value": "6 years"
   },
   {
      "label": "7 years",
      "value": "7 years"
   },
   {
      "label": "8 years",
      "value": "8 years"
   },
   {
      "label": "9+ years",
      "value": "9+ years"
   }
];

export const OTHER_OWNED_VEHICLE_NUMBER_OPTIONS = [
   {
      "label": "None",
      "value": "None"
   },
   {
      "label": "1",
      "value": "1"
   },
   {
      "label": "2",
      "value": "2"
   },
   {
      "label": "3",
      "value": "3"
   },
   {
      "label": "4",
      "value": "4"
   },
   {
      "label": "5+",
      "value": "5+"
   }
];

export const MOTOR_CYCLE_OWNER_OPTIONS = [
   {
      "label": 'Please Select',
      "value": ''
   },
   {
      "label": "Proposer/Policyholder",
      "value": "Proposer/Policyholder"
   },
   {
      "label": "Company Other Than Proposer",
      "value": "Company Other Than Proposer"
   },
   {
      "label": "Employee",
      "value": "Employee"
   },
   {
      "label": "Employer",
      "value": "Employer"
   },
   {
      "label": "Vehicle Leasing Company",
      "value": "Vehicle Leasing Company"
   },
   {
      "label": "Other",
      "value": "Other"
   },
   {
      "label": "Parent",
      "value": "Parent"
   },
   {
      "label": "Partner - Civil",
      "value": "Partner - Civil"
   },
   {
      "label": "Partner - Common Law",
      "value": "Partner - Common Law"
   },
   {
      "label": "Son or Daughter",
      "value": "Son or Daughter"
   },
   {
      "label": "Spouse",
      "value": "Spouse"
   }
];

export const MOTOR_CYCLE_KEEPER_OPTIONS = [
   {
      "label": 'Please Select',
      "value": ''
   },
   {
      "label": "Proposer/Policyholder",
      "value": "Proposer/Policyholder"
   },
   {
      "label": "Company Other Than Proposer",
      "value": "Company Other Than Proposer"
   },
   {
      "label": "Employer",
      "value": "Employer"
   },
   {
      "label": "Vehicle Leasing Company",
      "value": "Vehicle Leasing Company"
   },
   {
      "label": "Other",
      "value": "Other"
   },
   {
      "label": "Parent",
      "value": "Parent"
   },
   {
      "label": "Partner - Civil",
      "value": "Partner - Civil"
   },
   {
      "label": "Partner - Common Law",
      "value": "Partner - Common Law"
   },
   {
      "label": "Spouse",
      "value": "Spouse"
   }
];

export const MOTOR_CYCLE_PARKING_OPTIONS = [
   {
      "label": 'Please Select',
      "value": ''
   },
   {
      "label": "Car Park",
      "value": "Car Park"
   },
   {
      "label": "Carport",
      "value": "Carport"
   },
   {
      "label": "Garaged",
      "value": "Garaged"
   },
   {
      "label": "Kept On Private Property",
      "value": "Kept On Private Property"
   },
   {
      "label": "Kept On Public Road",
      "value": "Kept On Public Road"
   },
   {
      "label": "Locked Building",
      "value": "Locked Building"
   },
   {
      "label": "Locked Compound",
      "value": "Locked Compound"
   },
   {
      "label": "Parked On Drive",
      "value": "Parked On Drive"
   }
];

export const MOTOR_CYCLE_COVERAGE_TYPES = [
   {
      "label": 'Please Select',
      "value": ''
   },
   {
      "label": "Third Party Fire And Theft",
      "value": "Third Party Fire And Theft"
   },
   {
      "label": "Comprehensive",
      "value": "Comprehensive"
   },
   {
      "label": "Third Party Only",
      "value": "Third Party Only"
   }
];

export const MOTOR_CYCLE_VOLUNTARY_EXCESS_OPTIONS = [
   {
      "label": "£0",
      "value": "£0"
   },
   {
      "label": "£50",
      "value": "£50"
   },
   {
      "label": "£100",
      "value": "£100"
   },
   {
      "label": "£150",
      "value": "£150"
   },
   {
      "label": "£200",
      "value": "£200"
   },
   {
      "label": "£250",
      "value": "£250"
   },
   {
      "label": "£300",
      "value": "£300"
   },
   {
      "label": "£400",
      "value": "£400"
   },
   {
      "label": "£500",
      "value": "£500"
   },
   {
      "label": "£1000",
      "value": "£1000"
   }
];

export const TAXI_VEHICLE_TYPE_OPTIONS = [
   {
      "label": "Please Select",
      "value": ""
   },
   {
      "label": "BLACK CAB/HACKNEY CARRIAGE",
      "value": "BLACK CAB/HACKNEY CARRIAGE"
   },
   {
      "label": "CAR/SALOON",
      "value": "CAR/SALOON"
   },
   {
      "label": "MINIBUS",
      "value": "MINIBUS"
   },
   {
      "label": "MPV",
      "value": "MPV"
   },
   {
      "label": "OTHER",
      "value": "OTHER"
   }
];

export const TAXI_MAX_PASSENGER_OPTIONS = [
   {
      "label": "Please Select",
      "value": ""
   },
   {
      label: '3',
      value: '3',
   },
   {
      label: '4',
      value: '4',
   },
   {
      label: '5',
      value: '5',
   },
   {
      label: 'Other',
      value: 'Other',
   },
];

export const TAXI_INSURANCE_COVERAGE_TYPE_OPTIONS = [
   {"label": "Please select", "value": ""},
   {"label": "Comprehensive", "value": "Comprehensive"},
   {"label": "Third party fire & theft", "value": "Third party fire &amp; theft"},
   {"label": "Third party only", "value": "Third party only"}
];

export const VAN_BODY_TYPES = [
   {"label": "Please Select", "value": ""},
   {"label": "VAN", "value": "VAN"},
   {"label": "PICKUP", "value": "PICKUP"},
   {"label": "LUTON", "value": "LUTON"},
   {"label": "BOX VAN", "value": "BOX VAN"},
   {"label": "CANTEEN", "value": "CANTEEN"},
   {"label": "CURTAINSIDE", "value": "CURTAINSIDE"},
   {"label": "DOUBLE CAB", "value": "DOUBLE CAB"},
   {"label": "DROPSIDE", "value": "DROPSIDE"},
   {"label": "FLAT BED", "value": "FLAT BED"},
   {"label": "HORSEBOX", "value": "HORSEBOX"},
   {"label": "HOT FOOD DISPENSER", "value": "HOT FOOD DISPENSER"},
   {"label": "ICE CREAM VAN", "value": "ICE CREAM VAN"},
   {"label": "LOADER", "value": "LOADER"},
   {"label": "MILK FLOAT", "value": "MILK FLOAT"},
   {"label": "MOBILE SHOP", "value": "MOBILE SHOP"},
   {"label": "REFRIGERATED/INSULATED", "value": "REFRIGERATED/INSULATED"},
   {"label": "TIPPER", "value": "TIPPER"},
   {"label": "OTHER", "value": "OTHER"}
];

export const VAN_SEAT_OPTIONS = [
   {"label": "Please Select", "value": ""},
   {"label": "1", "value": "1"},
   {"label": "2", "value": "2"},
   {"label": "3", "value": "3"},
   {"label": "4", "value": "4"},
   {"label": "5", "value": "5"},
   {"label": "6", "value": "6"},
   {"label": "7", "value": "7"},
   {"label": "8", "value": "8"},
   {"label": "9", "value": "9"}
];

export const VAN_DOOR_OPTIONS = [
   {"label": "Please Select", "value": ""},
   {"label": "3 Doors", "value": "3 Doors"},
   {"label": "5 Doors", "value": "5 Doors"},
];

export const VAN_ROOF_TYPE_OPTIONS = [
   {"label": "Please Select", "value": ""},
   {"label": "Normal Roof", "value": "Normal Roof"},
   {"label": "High Roof", "value": "High Roof"},
];

export const VAN_WHEEL_BASE_OPTIONS = [
   {"label": "Please Select", "value": ""},
   {"label": "LONG WHEEL BASE", "value": "LONG WHEEL BASE"},
   {"label": "MEDIUM WHEEL BASE", "value": "MEDIUM WHEEL BASE"},
   {"label": "SHORT WHEEL BASE", "value": "SHORT WHEEL BASE"}
];

export const BUSINESS_CATEGORY_OPTIONS = [
   {"label": "SOLE TRADER", "value": "SOLE TRADER"},
   {"label": "PARTNERSHIP", "value": "PARTNERSHIP"},
   {"label": "LTD COMPANY", "value": "LTD COMPANY"}
];

export const BUSINESS_ACTIVITY_OPTIONS = [
   {"label": "Audit Work", "value": "Audit Work"},
   {"label": "Book Keeping", "value": "Book Keeping"},
   {"label": "Company flotations", "value": "Company flotations"},
   {"label": "Company/corporate Tax Consultancy", "value": "Company/corporate Tax Consultancy"},
   {"label": "Computer consultancy", "value": "Computer consultancy"},
   {
      "label": "Corporate Finance, Listed or Quoted companies",
      "value": "Corporate Finance, Listed or Quoted companies"
   },
   {"label": "Directorships, Executorships & Trusteeships", "value": "Directorships, Executorships & Trusteeships"},
   {"label": "General Accountancy", "value": "General Accountancy"},
   {"label": "Initial Public Offering of shares", "value": "Initial Public Offering of shares"},
   {"label": "Insolvency, Liquidation & Receivership", "value": "Insolvency, Liquidation & Receivership"},
   {
      "label": "Introducer Commissions From Third Party Intermediaries",
      "value": "Introducer Commissions From Third Party Intermediaries"
   },
   {"label": "Management Consultancy", "value": "Management Consultancy"},
   {"label": "Mergers, Acquisitions & Disposals", "value": "Mergers, Acquisitions & Disposals"},
   {"label": "Offshore work", "value": "Offshore work"},
   {"label": "Payroll", "value": "Payroll"},
   {"label": "Personal tax consultancy", "value": "Personal tax consultancy"},
   {"label": "Secretarial and share registrations", "value": "Secretarial and share registrations"},
   {"label": "Other", "value": "Other"}
];

export const CONVICTION_CODES = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "AC10",
      "value": "AC10"
   },
   {
      "label": "AC20",
      "value": "AC20"
   },
   {
      "label": "AC30",
      "value": "AC30"
   },
   {
      "label": "BA10",
      "value": "BA10"
   },
   {
      "label": "BA20",
      "value": "BA20"
   },
   {
      "label": "BA30",
      "value": "BA30"
   },
   {
      "label": "BA40",
      "value": "BA40"
   },
   {
      "label": "BA60",
      "value": "BA60"
   },
   {
      "label": "CD10",
      "value": "CD10"
   },
   {
      "label": "CD20",
      "value": "CD20"
   },
   {
      "label": "CD30",
      "value": "CD30"
   },
   {
      "label": "CD50",
      "value": "CD50"
   },
   {
      "label": "CD60",
      "value": "CD60"
   },
   {
      "label": "CD70",
      "value": "CD70"
   },
   {
      "label": "CD80",
      "value": "CD80"
   },
   {
      "label": "CD90",
      "value": "CD90"
   },
   {
      "label": "CU10",
      "value": "CU10"
   },
   {
      "label": "CU20",
      "value": "CU20"
   },
   {
      "label": "CU30",
      "value": "CU30"
   },
   {
      "label": "CU40",
      "value": "CU40"
   },
   {
      "label": "CU50",
      "value": "CU50"
   },
   {
      "label": "CU80",
      "value": "CU80"
   },
   {
      "label": "DD10",
      "value": "DD10"
   },
   {
      "label": "DD40",
      "value": "DD40"
   },
   {
      "label": "DD60",
      "value": "DD60"
   },
   {
      "label": "DD80",
      "value": "DD80"
   },
   {
      "label": "DD90",
      "value": "DD90"
   },
   {
      "label": "DR10",
      "value": "DR10"
   },
   {
      "label": "DR20",
      "value": "DR20"
   },
   {
      "label": "DR30",
      "value": "DR30"
   },
   {
      "label": "DR31",
      "value": "DR31"
   },
   {
      "label": "DR61",
      "value": "DR61"
   },
   {
      "label": "DR40",
      "value": "DR40"
   },
   {
      "label": "DR50",
      "value": "DR50"
   },
   {
      "label": "DR60",
      "value": "DR60"
   },
   {
      "label": "DR70",
      "value": "DR70"
   },
   {
      "label": "DG10",
      "value": "DG10"
   },
   {
      "label": "DG60",
      "value": "DG60"
   },
   {
      "label": "DR80",
      "value": "DR80"
   },
   {
      "label": "DG40",
      "value": "DG40"
   },
   {
      "label": "DR90",
      "value": "DR90"
   },
   {
      "label": "IN10",
      "value": "IN10"
   },
   {
      "label": "LC20",
      "value": "LC20"
   },
   {
      "label": "LC30",
      "value": "LC30"
   },
   {
      "label": "LC40",
      "value": "LC40"
   },
   {
      "label": "LC50",
      "value": "LC50"
   },
   {
      "label": "MS10",
      "value": "MS10"
   },
   {
      "label": "MS20",
      "value": "MS20"
   },
   {
      "label": "MS30",
      "value": "MS30"
   },
   {
      "label": "MS50",
      "value": "MS50"
   },
   {
      "label": "MS60",
      "value": "MS60"
   },
   {
      "label": "MS70",
      "value": "MS70"
   },
   {
      "label": "MS80",
      "value": "MS80"
   },
   {
      "label": "MS90",
      "value": "MS90"
   },
   {
      "label": "MW10",
      "value": "MW10"
   },
   {
      "label": "PC10",
      "value": "PC10"
   },
   {
      "label": "PC20",
      "value": "PC20"
   },
   {
      "label": "PC30",
      "value": "PC30"
   },
   {
      "label": "SP10",
      "value": "SP10"
   },
   {
      "label": "SP20",
      "value": "SP20"
   },
   {
      "label": "SP30",
      "value": "SP30"
   },
   {
      "label": "SP40",
      "value": "SP40"
   },
   {
      "label": "SP50",
      "value": "SP50"
   },
   {
      "label": "TS10",
      "value": "TS10"
   },
   {
      "label": "TS20",
      "value": "TS20"
   },
   {
      "label": "TS30",
      "value": "TS30"
   },
   {
      "label": "TS40",
      "value": "TS40"
   },
   {
      "label": "TS50",
      "value": "TS50"
   },
   {
      "label": "TS60",
      "value": "TS60"
   },
   {
      "label": "TS70",
      "value": "TS70"
   },
   {
      "label": "TT99",
      "value": "TT99"
   },
   {
      "label": "UT50",
      "value": "UT50"
   },
   {
      "label": "MR09",
      "value": "MR09"
   },
   {
      "label": "MR19",
      "value": "MR19"
   },
   {
      "label": "MR29",
      "value": "MR29"
   },
   {
      "label": "MR39",
      "value": "MR39"
   },
   {
      "label": "MR49",
      "value": "MR49"
   },
   {
      "label": "MR59",
      "value": "MR59"
   },
   {
      "label": "Other",
      "value": "Other"
   }
];

export class convictionPartiesList {
}

export class convictionTypes {
}